/* eslint-disable @typescript-eslint/naming-convention */

import { Box, ListItemButton, Stack, Typography } from '@mui/material';
import { ThemeContext } from 'App';
import React, { useContext } from 'react';

export default function NewUIBanner() {
  const themeContext = useContext(ThemeContext);

  const handleBannerClick = () => {
    if (themeContext.version) {
      themeContext.version.onChange('newUi');
      window.localStorage.setItem('theme-version', 'newUi');
    }
  };

  // Only show if theme-mode is not set in localStorage and current version is default
  const themeVersion = window.localStorage.getItem('theme-version');
  if (themeVersion !== null) {
    return null;
  }

  return (
    <ListItemButton
      onClick={handleBannerClick}
      sx={{
        borderRadius: 2,
        mx: 1,
        my: 0.5,
        p: 1,
        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.01) 100%)',
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.02) 100%)',
          borderColor: 'primary.main',
          transform: 'translateY(-1px)',
          boxShadow: 1,
        },
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ width: '100%' }}>
        <Box
          sx={{
            fontSize: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✨
        </Box>
        <Stack sx={{ flex: 1 }}>
          <Typography variant="body1">Check out our new look!</Typography>
          <Typography variant="body2" color="text.secondary">
            Click to switch to our refreshed interface
          </Typography>
        </Stack>
      </Stack>
    </ListItemButton>
  );
}
